import React, { FunctionComponent, useEffect, useState } from 'react';
import { SkeletonPage, SkeletonTable } from '@ui';
import { Loading } from '@shopify/polaris';

export enum LoadingPageType {
  FULLPAGE = 'FULLPAGE',
  TABLE = 'TABLE',
  CUSTOM = 'CUSTOM',
}

const LoadingIndicator: FunctionComponent<{
  type: LoadingPageType;
  isSectionedLayout?: boolean;
  pageTitle?: string;
  secondaryTitle?: string;
  cardTitles?: string[];
  loading: boolean;
  hideSkeleton?: boolean;
  children: React.ReactNode;
  customSkeleton?: React.ReactNode;
}> = (props) => {
  const {
    cardTitles,
    children,
    customSkeleton,
    hideSkeleton,
    isSectionedLayout,
    loading: loadingProp,
    pageTitle,
    secondaryTitle,
    type,
  } = props;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    if (!hideSkeleton) {
      timer = setTimeout(() => {
        setLoading(loadingProp);
      }, 250);
    }

    if (hideSkeleton || loadingProp) {
      setLoading(loadingProp);
    }

    return () => timer && clearTimeout(timer);
  }, [hideSkeleton, loadingProp]);

  return (
    <>
      {loading && <Loading />}
      {!hideSkeleton && loading && type === LoadingPageType.TABLE && (
        <SkeletonTable pageTitle={pageTitle} />
      )}
      {!hideSkeleton && loading && type === LoadingPageType.FULLPAGE && (
        <SkeletonPage
          pageTitle={pageTitle}
          secondaryTitle={secondaryTitle}
          cardTitles={cardTitles}
          isSectionedLayout={isSectionedLayout}
        />
      )}
      {!hideSkeleton &&
        loading &&
        type === LoadingPageType.CUSTOM &&
        customSkeleton}
      {(hideSkeleton || !loading) && children}
    </>
  );
};

export default LoadingIndicator;
